import { twMerge } from 'tailwind-merge';
import {
  ComponentPropsWithRef,
  ComponentType,
  ElementType,
  FunctionComponent,
  forwardRef,
} from 'react';

export function withClassName<T extends ComponentType<any> | ElementType<any>>(
  Component: T,
  ...cs: Parameters<typeof twMerge>
): FunctionComponent<ComponentPropsWithRef<T>> {
  const WithClassName = forwardRef<any, any>((props, ref) => {
    const { className, ...rest } = props;
    // React 19 tightens generic component prop-spread typing (rejects both
    // raw `{...rest}` and `rest as ComponentPropsWithRef<T>` with TS2322
    // "not assignable to LibraryManagedAttributes<T, any>"). `as any` is
    // load-bearing here; a narrower cast does not compile.
    return <Component ref={ref} {...(rest as any)} className={twMerge(cs, className)} />;
  });
  return WithClassName as any;
}
